import React from 'react';
import { NeoGrid, Neo } from '@singularsystems/neo-react';
import { AppService, Types } from '../../../../App/Services/AppService';
import { observer } from 'mobx-react';
import { TextConstants } from '../../../../Common/TextConstants';
import AuthorisationVM from '../AuthorisationVM';
import { NotifyUtils } from '@singularsystems/neo-core';
import InviteUserCommand from '../../../Models/Commands/UserCommands/InviteUserCommand';

interface IInvitedUsersComponentProps {
    viewModel: AuthorisationVM;
}

@observer
export default class InvitedUsersComponent extends React.Component<IInvitedUsersComponentProps> {

    public async submitUserReinvite(emailAddress: string) {
        var inviteUser = new InviteUserCommand();
        inviteUser.postRegisterRedirectURL = AppService.get(Types.Config).baseUrl;
        inviteUser.inviteEmailAddress = emailAddress;
        this.props.viewModel.taskRunner.run(async () => {
            await this.props.viewModel.usersApiClient.reinviteUser(inviteUser!.toJSObject());
            NotifyUtils.add("User invite sent", `The invite will be resent to ${emailAddress}.`,
                "success" as any, 10);
        });
    }

    public render() {
        var viewModel = this.props.viewModel;

        return (
            <Neo.Tab header={TextConstants.Titles.InvitedUsers} onDisplayed={viewModel.loadInvitedUsers} >
                <Neo.Card title={TextConstants.Titles.InvitedUsers} className="ml-3 mr-3" >

                    <NeoGrid.Grid
                        items={viewModel.userNameLookupList} >
                        {(item, meta) => (
                            <NeoGrid.Row>
                                <NeoGrid.Column display={meta.userName} />
                                <NeoGrid.ButtonColumn>
                                    <Neo.Button
                                        onClick={() => this.submitUserReinvite(meta.userName.value)}
                                        variant="primary" >
                                        <span className="mt-1">{TextConstants.Buttons.Reinvite}</span>
                                    </Neo.Button>
                                </NeoGrid.ButtonColumn>
                            </NeoGrid.Row>)}
                    </NeoGrid.Grid>

                    {viewModel.userNameLookupList.length === 0 &&
                        <div className="col-md-12 text-center">
                            <p>{TextConstants.GeneralText.NoRecords}</p>
                        </div>}

                </Neo.Card>
            </Neo.Tab>
        );
    }
}